// Page ouverte depuis le lien de confirmation de l'e-mail : tente d'ouvrir
// l'app, et dit si le lien a fonctionné.
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Tiggy from "../site/Tiggy";
import BoutonsStores from "../site/BoutonsStores";

function EmailConfirmed() {
	const [searchParams] = useSearchParams();
	const status = searchParams.get("status") || "success";
	const isSuccess = status === "success";

	useEffect(() => {
		if (isSuccess) {
			window.location.href = "gymnote://email-confirme";
		}
	}, [isSuccess]);

	return (
		<section className="gs-page">
			<div className="gs-quadrillage gs-quadrillage--page" />
			<div className="gs-conteneur">
				<div className="gs-carte gs-page-carte">
					<Tiggy pose={isSuccess ? "victoire" : "reflexion"} taille={150} />
					<h1 className="gs-page-titre">{isSuccess ? "E-mail confirmé" : "Lien expiré"}</h1>
					<p className="gs-texte">
						{isSuccess
							? "Ton compte GymNote est maintenant actif. Ouvre l'application pour te connecter."
							: "Ce lien de confirmation n'est plus valide, ou a déjà été utilisé. Si tu es déjà connecté à l'app, tout est bon ; sinon, demande un nouveau lien depuis l'écran d'inscription."}
					</p>
					<BoutonsStores />
				</div>
			</div>
		</section>
	);
}

export default EmailConfirmed;
